import Popup from "reactjs-popup";
import styled from "styled-components";

export const StyledPopup = styled(Popup)`
  &-overlay {
    z-index: 10000 !important;
  }
  &-content {
    width: 100% !important;
    max-width: 540px !important;
    min-height: 396px !important;
    height: auto !important;
    box-sizing: border-box !important;
    z-index: 10001 !important;
    padding: 0 !important;
    border: none !important;
    border-radius: 10px;
    box-shadow: 1px 1px 4px 0 rgba(22, 22, 29, 0.3);
    background-color: #fff;
    margin: auto;
    & .container {
      box-sizing: border-box;
      width: 100%;
      max-width: 540px;
      min-height: 396px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: stretch;
      gap: 25px;
      padding: 32px 20px 24px;
      border: none;
      border-radius: 10px;
      background-color: #fff;
      cursor: default;
      overflow: visible;
    }
    @media (max-width: ${(props) => props.theme.breakpoints.xs}) {
      width: calc(100vw - 32px) !important;
      max-width: 540px !important;
      min-height: auto !important;

      & .container {
        min-height: auto;
        padding: 24px 20px;
      }
    }
  }
`;

export const Content = styled.div`
  align-self: stretch;
  flex-grow: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
  padding: 0;
`;

export const IconWrap = styled.div`
  display: flex;
  justify-content: center;
`;

export const HeadCard = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const Title = styled.h3`
  width: 100%;
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  color: #3a3a3a;
`;

export const Intro = styled.p`
  width: 100%;
  margin: 0;
  font-size: 15px;
  line-height: 1.5;
  font-weight: 400;
  text-align: center;
  color: #5a5a5a;
`;

export const Footer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 12px;

  & button {
    box-sizing: border-box;
    flex-shrink: 0;
    height: 67px;
    margin-right: 0;
    gap: 10px;
    font-size: 18px;
    font-weight: 700;
    border-radius: 5px;
    white-space: normal;
    line-height: 1.2;
  }

  /* Botón izquierdo "Sí, es correcta". */
  & button:first-of-type {
    width: 163px;
  }

  /* Botón derecho "Solicitar cambio de dirección". */
  & button:last-of-type {
    width: 301px;
    border-width: 1px;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.xs}) {
    flex-direction: column;
    align-items: center;

    & button:first-of-type,
    & button:last-of-type {
      width: 100%;
      max-width: 301px;
    }
  }
`;
